import React from 'react'
import { content } from './components'
import { Project } from 'src/core/models'
import styles from './ProjectDetails.module.scss'
import { getProjectDetailsSection } from './components/sections'

interface ProjectDetailsProps {
  project: Project
  isModalPreview?: boolean
  saleOfferContent?: React.ReactNode
}

const ProjectDetails: React.FC<ProjectDetailsProps> = (props) => {
  const { project, isModalPreview = false, saleOfferContent = null } = props
  const sections = getProjectDetailsSection(project, isModalPreview)

  return (
    <div className={'fade-animation'}>
      <content.ProjectDetailMainCard
        project={project}
        isModalPreview={isModalPreview}
        saleOfferContent={saleOfferContent}
      />

      <div className={styles.panelsSection}>
        {sections.map((section, idx) => <div key={idx}>
          {section.isVisible && <>{section.component}</>}
        </div>)}
      </div>
    </div>
  )
}

export default ProjectDetails
